import { useEffect, useState } from 'react';
import axios from 'axios';
import WithdrawModal from './WithdrawalModal';
import styles from './AdminDashboard.module.css';

const API_BASE = '/api/admin';

const WithdrawalsPage = () => {
  const [withdrawals, setWithdrawals] = useState([]);
  const [selectedWithdraw, setSelectedWithdraw] = useState(null);
  const [showWithdrawModal, setShowWithdrawModal] = useState(false);
  const [page, setPage] = useState(1);
  const WITHDRAWS_PER_PAGE = 10;

  useEffect(() => {
    const fetchWithdrawals = async () => {
      try {
        const token = localStorage.getItem("adminAccessToken");

        const res = await axios.get(`${API_BASE}/withdraw?period=week`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setWithdrawals(res.data.data || []);
      } catch (error) {
        console.error('Error fetching withdrawals:', error);
      }
    };

    fetchWithdrawals();
  }, []);

  const handleWithdrawDetails = async (withdrawId) => {
    try {
      const token = localStorage.getItem("adminAccessToken");

      const res = await axios.get(`${API_BASE}/withdraw/${withdrawId}/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setSelectedWithdraw(res.data);
      setShowWithdrawModal(true);
    } catch (err) {
      console.error('Failed to fetch withdrawal details:', err);
    }
  };

  const handleRejectWithdraw = async (id) => {
    try {
      const token = localStorage.getItem("adminAccessToken");

      await axios.post(`${API_BASE}/withdraw/${id}/reject`, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const updated = withdrawals.map(w =>
        w.id === id ? { ...w, status: 'fail' } : w
      );
      setWithdrawals(updated);
    } catch (error) {
      console.error('Error rejecting withdraw:', error);
    }
  };

  const handleApproveWithdraw = async (id, txid) => {
    try {
      const token = localStorage.getItem("adminAccessToken");

      await axios.put(`${API_BASE}/withdraw/${id}/update`, { txid }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const updated = withdrawals.map(w =>
        w.id === id ? { ...w, status: 'success', txid } : w
      );
      setWithdrawals(updated);
    } catch (error) {
      console.error('Error approving withdraw:', error);
    }
  };

  return (
    <div className={styles.pageContainer}>
      <h1>Withdrawals</h1>
      <div className={styles.card}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>ID</th>
              <th>User ID</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Coin</th>
              <th>Created At</th>
            </tr>
          </thead>
          <tbody>
            {withdrawals
              .slice((page - 1) * WITHDRAWS_PER_PAGE, page * WITHDRAWS_PER_PAGE)
              .map(w => (
                <tr key={w.id} onClick={() => handleWithdrawDetails(w.id)}>
                  <td>{w.id}</td>
                  <td>{w.user_id}</td>
                  <td>{w.amount}</td>
                  <td>{w.status}</td>
                  <td>{w.coin_symbol}</td>
                  <td>{new Date(w.created_at).toLocaleString()}</td>
                </tr>
            ))}
          </tbody>
        </table>
        <div className={styles.pagination}>
          <button
            onClick={() => setPage(p => Math.max(p - 1, 1))}
            disabled={page === 1}
          >
            Previous
          </button>
          <span>Page {page} / {Math.ceil(withdrawals.length / WITHDRAWS_PER_PAGE)}</span>
          <button
            onClick={() => setPage(p => Math.min(p + 1, Math.ceil(withdrawals.length / WITHDRAWS_PER_PAGE)))}
            disabled={page === Math.ceil(withdrawals.length / WITHDRAWS_PER_PAGE)}
          >
            Next
          </button>
        </div>
      </div>
      {showWithdrawModal && (
        <WithdrawModal
          withdraw={selectedWithdraw}
          onClose={() => setShowWithdrawModal(false)}
          onReject={handleRejectWithdraw}
          onApprove={handleApproveWithdraw}
        />
      )}
    </div>
  );
};

export default WithdrawalsPage;
